import { Collapse, Input } from "reactstrap";
import { useState } from "react";
import { Toggle } from "rsuite";

import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";
import { FileInterface } from "../../../../../types/RecordInterfaces";
import { uploadImage } from "../../../../../utils/GeneralUtils";
import TenantAPI from "../../../../../api/api/TenantAPI";
import { FileDndWithHeader } from "./FileDnd";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
}

const Header = ({ form, setForm }: Props) => {
  const [uploading, setUploading] = useState(false);

  const handleSetForm = (value: any, key: string) => {
    setForm({ ...form.Header, [key]: value }, "Header");
  };

  const handleUploadImage = (apiName: string) => async (e: any) => {
    setUploading(true);
    const sourceList: any = form?.id
      ? [
          {
            Source: "Record",
            SourceID: form?.id,
            SourceModule: "Forms",
            FieldAPIName: `Header.${apiName}`,
          },
        ]
      : undefined;

    try {
      const data = await uploadImage(
        e.target.files[0],
        true,
        true,
        true,
        sourceList
      );

      if (typeof data === "string") return;

      const imageObject = data.files[0];

      handleSetForm(imageObject, apiName);
    } catch {
    } finally {
      setUploading(false);
    }
  };

  const handleRemoveImage = (apiName: "CoverImage" | "Logo") => {
    RemoveImage(
      form?.id ?? "",
      apiName,
      form?.Header?.id || "",
      form?.Header?.[apiName]
    );

    handleSetForm({}, apiName);
  };

  const handleToggleDisableGCLogo = (value: boolean) => {
    if (value === false) {
      RemoveImage(
        form?.id ?? "",
        "Header.Logo",
        form?.Header?.id ?? "",
        form.Header?.Logo
      );

      setForm({ ...form.Header, DisableGCLogo: false, Logo: {} }, "Header");
    } else {
      handleSetForm(value, "DisableGCLogo");
    }
  };

  return (
    <div className="mb-4 text-sm text-dark font-weight-500">
      <label className="mb-1">Form Name</label>
      <Input
        value={form.Header?.Name ?? ""}
        bsSize="sm"
        onChange={(e) => handleSetForm(e.target.value, "Name")}
        required
      />
      <label className="mt-3 mb-1">Title</label>
      <Input
        value={form.Header?.Title ?? ""}
        bsSize="sm"
        onChange={(e) => handleSetForm(e.target.value, "Title")}
      />
      <label className="mt-3 mb-1">Description</label>
      <Input
        type="textarea"
        rows={3}
        value={form.Header?.Description ?? ""}
        bsSize="sm"
        onChange={(e) => handleSetForm(e.target.value, "Description")}
      />
      <FileDndWithHeader
        upload={handleUploadImage("CoverImage")}
        uploading={uploading}
        handleRemoveImage={() => handleRemoveImage("CoverImage")}
        title="Cover Image"
        file={form.Header?.CoverImage?.PublicURL}
      />
      <div className="d-flex justify-content-between mt-4">
        <label>Hide GrowthCloud Logo</label>
        <Toggle
          onChange={handleToggleDisableGCLogo}
          size="sm"
          checked={form.Header?.DisableGCLogo ?? false}
        />
      </div>
      <Collapse isOpen={form.Header?.DisableGCLogo}>
        <FileDndWithHeader
          upload={handleUploadImage("Logo")}
          uploading={uploading}
          handleRemoveImage={() => handleRemoveImage("Logo")}
          title="Custom Logo"
          file={form.Header?.Logo?.PublicURL}
        />
      </Collapse>
    </div>
  );
};

export function RemoveImage(
  recordID: string,
  fieldAPIName: string,
  subitemID: string,
  file?: FileInterface
) {
  if (!file) return;

  const blobName = file?.File;
  const fileID = file?.RecordID;
  const moduleAPIName = "Forms";
  // If not file.RecordID is not found, then removing the file by blobName.
  let body = fileID
    ? {
        type: "fileID" as const,
        fileID: fileID,
        fieldAPIName,
        moduleAPIName,
        recordID,
        subitemID,
      }
    : {
        type: "blobName" as const,
        blobName,
        fieldAPIName,
        moduleAPIName,
        recordID,
        subitemID,
      };

  TenantAPI.deleteFiles(body);
}

export default Header;
